import { make } from 'vuex-pathify';
import { filter, includes, keys, keyBy, remove, shuffle, sortBy, upperFirst, values } from 'lodash';

const quiz = keyBy(
    [
        {
            id: 1,
            question: 'Trans people can tell our own stories! Who is a writer, director, and producer of a TV show?',
            name: 'Janet Mock',
            bio:
                'Janet Mock (she/her) is a journalist, actress, author, and activist. In 2011, she publicly came out as a trans woman through an article in Marie Claire magazine. Janet thinks it’s very important for members of the trans community to write their own stories in their own words. She has gone on to write two memoirs about her life as a trans woman, and she continues to fight for representation of diverse transgender folks in the media. Currently, she writes, produces, and directs “Pose”, a TV show about trans and queer folks living in New York City in the 1980s. The show is groundbreaking for several reasons, including that most of the cast and crew is LGBTQ+ identified. She lives in NYC with her husband, Aaron.',
            image: require('@/assets/transbios/janet.png'),
            correct: false
        },
        {
            id: 2,
            question: 'Trans people can fight for our rights! Who are activists and founders of S.T.A.R.?',
            name: 'Marsha P. Johnson and Sylvia Rivera ',
            bio:
                "Sylvia Rivera (she/her) and Marsha P. Johnson (she/her), both transgender women of color, were activists and artists. Marsha and Sylvia were both popular figures in New York City's art and drag scene in the 1960s. They co-founded Street Transvestite Action Revolutionaries, better known as S.T.A.R. Through their work with S.T.A.R., they provided housing and support to homeless queer youth in NYC. Marsha and Sylvia participated in many clashes with the police, including the Stonewall Riot in 1969, which sparked the modern LGBTQ+ liberation movement.",
            image: require('@/assets/transbios/marshasylvia.png'),
            correct: false
        },
        {
            id: 3,
            question: 'Trans people can be politicians! Who is a politician?',
            name: 'Andrea Jenkins',
            bio:
                'Andrea Jenkins (she/her) is a writer, performance artist, poet, and transgender activist. She is the first African American openly trans woman to be elected to office in the United States serving since January 2018 on the Minneapolis City Council. She grew up in Chicago. As a City Council member, Andrea is working to promote greater equity for women, people of color, young people, and LGBTQ+ individuals.',
            image: require('@/assets/transbios/andrea.png'),
            correct: false
        },
        {
            id: 4,
            question: 'Trans people turn our experiences into art. Who is a poet and performance artist?',
            name: 'Alok Vaid-Menon',
            bio:
                'Alok Vaid-Menon (they/them) is a performance artist, poet, and LGBTQ+ rights activist. They identify as gender non-conforming and transfeminine.  Alok is Indian American and was raised Hindu while growing up in Texas. They graduated from Stanford University and released a book of poems titled FEMME IN PUBLIC in 2017.',
            image: require('@/assets/transbios/alok.png'),
            correct: false
        },
        {
            id: 5,
            question: 'Trans people can be entrepreneurs. Who is a CEO and founded a non-profit organization?',
            name: 'Michaela Ivri Mendelsohn',
            bio:
                'Michaela Ivri Mendelsohn (she/her) is a transgender activist, public speaker, and businesswoman with over forty years of entrepreneurial leadership experience. She is currently the CEO of Pollo West Corp, which operates six restaurants in the LA area. She also founded the California Transgender Workplace Program to promote trans-friendly job conditions. She is the first trans woman to join the board of The Trevor Project. She is the proud parent of 3 adult children and lives with her partner, Carmel, and their son in California.',
            image: require('@/assets/transbios/michaela.png'),
            correct: false
        }
    ],
    'id'
);
const quizOrder = shuffle(keys(quiz)); // shuffle once, on module creation

const facts = keyBy(
    [
        {
            id: 1,
            question: 'Where were you born?',
            template: '{{Name}} was born in {{1}}.',
            templateP: '{{Name}} were born in {{1}}.',
            selected: false,
            value1: '',
            label1: 'Birthplace'
        },
        {
            id: 2,
            question: 'What neighborhood do you live in?',
            template: '{{Name}} currently lives in {{1}}.',
            templateP: '{{Name}} currently live in {{1}}.',
            selected: false,
            value1: '',
            label1: 'Neighborhood'
        },
        {
            id: 3,
            question: 'What are three things about yourself? (for example: funny, fierce, supportive friend)',
            template: '{{Name}} is {{1}}, {{2}}, and {{3}}.',
            templateP: '{{Name}} are {{1}}, {{2}}, and {{3}}.',
            selected: false,
            value1: '',
            label1: 'Thing 1',
            value2: '',
            label2: 'Thing 2',
            value3: '',
            label3: 'Thing 3'
        },
        {
            id: 4,
            question: 'How old are you?',
            template: '{{Name}} is {{1}} years old.',
            templateP: '{{Name}} are {{1}} years old.',
            selected: false,
            value1: '',
            label1: 'Age',
            type1: 'number'
        },
        {
            id: 5,
            question: 'What is your proudest accomplishment?',
            template: '{{Name}} has accomplished a lot, including {{1}}.',
            templateP: '{{Name}} have accomplished a lot, including {{1}}.',
            selected: false,
            value1: '',
            label1: 'Proudest accomplishment'
        },
        {
            id: 6,
            question: 'What will be your “legacy” — something positive you do or create for the trans community?',
            template: 'To the next generation of LS children, {{name}} will leave a legacy of {{1}}.',
            templateP: 'To the next generation of LS children, {{name}} will leave a legacy of {{1}}.',
            selected: false,
            value1: '',
            label1: 'Legacy'
        },
        {
            id: 7,
            question: 'What’s something on your bucket list? (for example: somewhere you want to travel)',
            template: 'Someday, {{name}} is going to {{1}}.',
            templateP: 'Someday, {{name}} are going to {{1}}.',
            selected: false,
            value1: '',
            label1: 'Bucket list'
        },
        {
            id: 8,
            question: 'Who do you look up to and why?',
            template: '{{Name}} looks up to {{1}} because {{2}}.',
            templateP: '{{Name}} look up to {{1}} because {{2}}.',
            selected: false,
            value1: '',
            label1: 'Who',
            value2: '',
            label2: 'Why'
        }
    ],
    'id'
);
const factsOrder = sortBy(keys(facts), k => parseInt(k));
const factsSelectedQueue = [];
const MAX_SELECTED_FACTS = 4;

const state = {
    title: 'Icon Promo',
    complete: false,
    sticker: {
        text: 'Crown Icon',
        earned: false,
        image: require('@/assets/stickers/stickers_0003_crown.png')
    },
    bonusSticker: false,
    trophy: false,
    quiz,
    quizOrder,
    facts,
    factsOrder,
    factsSelectedQueue
};
const getters = {
    ...make.getters(state),
    currentQuizItem: state => {
        const remaining = shuffle(filter(values(state.quiz), { correct: false })); // shuffle the remaining unanswered questions
        if (remaining && remaining.length) {
            return state.quiz[remaining[0].id]; // pick from the top of the shuffled remaining pile
        }
        return null;
    },
    maxFactsSelected: state => {
        return filter(values(state.facts), { selected: true }).length >= MAX_SELECTED_FACTS;
    },
    selectedFacts: state => {
        return sortBy(filter(values(state.facts), { selected: true }), 'id');
    },
    factText: (state, getters, rootState) => (id, index) => {
        const name =
            0 === index
                ? rootState.preferences.name
                : rootState.preferences.noPronoun
                ? rootState.preferences.name
                : rootState.preferences.pronoun.split(/\/|-/)[0].trim();
        const template = 0 === index || 'they' !== rootState.preferences.pronoun ? state.facts[id].template : state.facts[id].templateP;
        return template
            .replace('{{name}}', name || '____')
            .replace('{{Name}}', upperFirst(name || '____'))
            .replace('{{1}}', state.facts[id].value1 || '____')
            .replace('{{2}}', state.facts[id].value2 || '____')
            .replace('{{3}}', state.facts[id].value3 || '____');
    }
};
const mutations = {
    ...make.mutations(state),
    selectFact(state, fact) {
        if (includes(state.factsSelectedQueue, fact.id)) {
            state.facts[fact.id].selected = false;
            remove(state.factsSelectedQueue, value => {
                return value === fact.id;
            });
        } else {
            state.factsSelectedQueue.push(fact.id);
            if (state.factsSelectedQueue.length > MAX_SELECTED_FACTS) {
                const id = state.factsSelectedQueue.shift();
                state.facts[id].selected = false;
            }
            state.facts[fact.id].selected = true;
        }
    }
};
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
